import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Api, IbmEndPoint } from '../../Model/api-model';
import { environment } from '../../../environments/environment';
import { RestApiService } from 'src/app/Services/rest-api-service';
import {Message,MessageService} from 'primeng/api';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { SwaggerUIBundle, SwaggerUIStandalonePreset } from "swagger-ui-dist";
import { MySubscriptions, Subscription, ProductPlan, Plan, PlanApis } from 'src/app/Model/product-model';
@Component({
  selector: 'app-swag',
  templateUrl: './swagger.component.html'
})
export class SwaggerComponent {
  apiID;
  apiURL;
  showDiv=false;
 showEndDiv=true;
 basPath:string;
  endpoints:IbmEndPoint[];
  pathforApis;
  constructor(private http: HttpClient,private route: ActivatedRoute) { 

    this.basPath=JSON.parse(localStorage.getItem("basePath"));
    this.endpoints= JSON.parse(localStorage.getItem("endpoints"));

    console.log(this.endpoints);
    this.route.params.subscribe(params => {
      this.apiID=params['id'];
      this.pathforApis=params['path'];
      console.log("ddddddddddddddddddddddddd "+ this.pathforApis);
      this.apiURL = environment.getSpringBootApiUrl();
  
    })

        if(localStorage.getItem("showinfo")){
           this.showDiv=true;
        }

  }
  ngAfterViewInit() {
    const ui = SwaggerUIBundle({
     // url:  "https://iopapicdevportalservicesvte-oci-dev.aetapps-dev.aetna.com/iopapicdevportalservicesvte/v1/devportalusers/api/5f0c70bbe4b003d499c65cdc",
      url:this.callMethod(),
      requestInterceptor: async a => {
        const token = "well"
        a.headers['Authorization'] = 'Bearer ' + localStorage.getItem("devportal_apic_token");
        a.headers['id_token'] = localStorage.getItem("devportal_id_token");


        a.headers['org_id_demo'] =localStorage.getItem("org_id_demo");
        a.headers['org_id_prod']=localStorage.getItem("org_id_prod");
        a.headers['path']=this.pathforApis;
        return a
      },
      dom_id: '#swagger-ui',
      deepLinking: false,
      defaultModelsExpandDepth:-1,
      presets: [
        SwaggerUIBundle.presets.apis
      //  SwaggerUIStandalonePreset
      ]
    })
  
  
  
  
  
  
  
  
  
  
  }

 callMethod(){
  

  const requestUrl=this.apiURL+"api/"+this.apiID;
  return   (requestUrl);
  
 }


 
 
}
